module.exports = __webpack_public_path__ + "0ec5efc3034fe3d43850bea19b49ead6.png";